/* eslint-disable import/prefer-default-export */
import {
  FETCH_RENOVATION_TABLE_DATA,
  FETCH_SIMULATED_RENOVATION_TABLE_DATA,
  RESET_RENOVATION_SUMMARY_TABLE_DATA,
  SAVE_RENOVATION_SIMULATION_TABLE_DATA
} from 'src/constants';
import { axios } from 'src/lib';

export function fetchRenovationTableData(
  body: any,
  sourceId: number,
  moduleId: number,
  scenarioId: number
) {
  return axios
    .post(
      `${FETCH_RENOVATION_TABLE_DATA}${sourceId}/${moduleId}/${scenarioId}/`,
      body
    )
    .then((response) => response.data);
}

export function resetSimulationData(
  sourceId: number,
  moduleId: number,
  scenarioId: number
) {
  return axios
    .post<any>(
      `${RESET_RENOVATION_SUMMARY_TABLE_DATA}${sourceId}/${moduleId}/${scenarioId}/`,
      { filter_inputs: [] }
    )
    .then((response) => response.data);
}

export function fetchSimulatedRenovationTableData(
  body: any,
  sourceId: number,
  moduleId: number,
  scenarioId: number
) {
  return axios
    .post(
      `${FETCH_SIMULATED_RENOVATION_TABLE_DATA}${sourceId}/${moduleId}/${scenarioId}/`,
      body
    )
    .then((response) => response.data);
}

export function saveRenovationSimulation(
  sourceId: number,
  moduleId: number,
  scenarioId: number
) {
  return axios
    .post(
      `${SAVE_RENOVATION_SIMULATION_TABLE_DATA}${sourceId}/${moduleId}/${scenarioId}/`,
      {}
    )
    .then((response) => response.data);
}
